import connect from "@escapio/shared/data-store/connect";
import { store, ACTION_SET_SORTING } from "../DataStore";
import {
	BY_POPULARITY,
	BY_PRICE_AND_POPULARITY,
	BY_SCORE_AND_POPULARITY,
} from "./Sorters";
import { SortingSelector as Base } from "../../SortingSelector";
import { track } from "@escapio/portal/tracker/EventTracker";
import { travelData } from "@escapio/portal/state/travelData";

export class Selector extends connect(Base, store) {
	constructor(options) {
		super(options);
		this.allOptions = this.options;
	}

	update(state) {
		this.options = !travelData.hasDates
			? this.allOptions.filter(({ value }) => value !== BY_PRICE_AND_POPULARITY)
			: this.allOptions;

		this.selectedValue = state.sorting;
		this.render();
	}

	setValue(value) {
		this.dispatchAction(ACTION_SET_SORTING, value);
		track(
			"Liste",
			"Sortierung",
			{
				[BY_POPULARITY]: "Popularitaet",
				[BY_PRICE_AND_POPULARITY]: "Preis",
				[BY_SCORE_AND_POPULARITY]: "Bewertungen",
			}[value],
		);
	}
}
